module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAPFBMVEX///98g4l3goh3gIh5fYZ2foV1e4R0fYJ0fINze4R0e4R1e4Rze4J0e4JzeoNzeoJ0e4NzeYJzeoJzeoLjkey1AAAAE3RSTlMCKSs6O0VVVmdobHiJj5C8vb/2y9pDGgAAAAFiS0dEAIgFHUgAAABfSURBVBjThZBbDoAgDMAK+HYgyP3v6ocgYIj2izQp2QY9hr3CAOBjhQcghFKk9486pkfdH4FGZSUiIgK4U71Cia4KQzE5XMAmU0IbLbpRa7TMR6PG7Wv6ztpGKkz3fhcffge4uVT+/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-repair-apply.png
// module id = HHkF
// module chunks = 1